import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { API_PATHS } from './api-paths';

export interface Parceiro {
  parceiroUuid: string;
  nome: string;
  cpfCnpj: string | null;
  telefone: string | null;
  limiteUsuarios: number;
  emailAcesso: string | null;
  criadoEm: string;
  ativo: boolean;

  rua?: string | null;
  cidade?: string | null;
  estado?: string | null;
  cep?: string | null;
  pais?: string | null;
}

export interface ParceiroPayload {
  nome: string;
  cpfCnpj: string;
  emailAcesso: string;
  telefone: string;
  limiteUsuarios: number;
  rua: string;
  cidade: string;
  estado: string;
  cep: string;
  pais: string;
}

@Injectable({
  providedIn: 'root',
})
export class ParceirosService {
  private readonly http = inject(HttpClient);

  private readonly url = environment.apiUrl + API_PATHS.parceiros;

  listar() {
    return this.http.get<Parceiro[]>(this.url);
  }

  criar(dados: ParceiroPayload) {
    return this.http.post<Parceiro>(this.url, dados);
  }

  atualizar(parceiroUuid: string, dados: ParceiroPayload) {
    return this.http.put<Parceiro>(`${this.url}/${parceiroUuid}`, dados);
  }

  alterarStatus(parceiroUuid: string, ativo: boolean) {
    return this.http.patch<void>(
      `${this.url}/${parceiroUuid}/status`,
      { ativo }
    );
  }

  excluir(parceiroUuid: string) {
    return this.http.delete<void>(`${this.url}/${parceiroUuid}`);
  }
}
